/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Faq_3_AnswerInputs */

const en_svc_research_faq_3_answer = /** @type {(inputs: Svc_Research_Faq_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It depends on the questions, the sources and how often it runs. After a short discovery we propose a fixed scope, timeline and price, and running costs are capped per run.`)
};

const lv_svc_research_faq_3_answer = /** @type {(inputs: Svc_Research_Faq_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tas atkarīgs no jautājumiem, avotiem un tā, cik bieži tas darbojas. Pēc īsas izpētes piedāvājam noteiktu apjomu, termiņu un cenu, un darbības izmaksas ir ierobežotas katrai palaišanai.`)
};

/**
* | output |
* | --- |
* | "It depends on the questions, the sources and how often it runs. After a short discovery we propose a fixed scope, timeline and price, and running costs are c..." |
*
* @param {Svc_Research_Faq_3_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_faq_3_answer = /** @type {((inputs?: Svc_Research_Faq_3_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Faq_3_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_faq_3_answer(inputs)
	return en_svc_research_faq_3_answer(inputs)
});